import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_REC023_Request,
  IAPI_REC023_Response,
} from "../../../type/apiType";
import {
  IAPI_REC016_Request,
  IAPI_REC016_Response,
} from "../../../type/apiType";
import {
  IAPI_REC005_Request,
  IAPI_REC005_Response,
} from "../../../type/apiType";
import {
  IAPI_REC024_Request,
  IAPI_REC024_Response,
} from "../../../type/apiType";
import {
  IAPI_REC025_Request,
  IAPI_REC025_Response,
} from "../../../type/apiType";
import {
  IAPI_REC017_Request,
  IAPI_REC017_Response,
} from "../../../type/apiType";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

/**
 * 仕分け結果詳細参照API
 * @return
 */
const httpAPI_REC023 = async (
  param: IAPI_REC023_Request
): Promise<IAPI_REC023_Response> => {
  let res = await http.post(ApiUrl.API_REC023, {
    ...param,
  });

  return res.data;
};

/**
 * 請求一覧参照API
 * @return
 */
const httpAPI_REC016 = async (
  param: IAPI_REC016_Request
): Promise<IAPI_REC016_Response> => {
  let res = await http.post(ApiUrl.API_REC016, {
    ...param,
  });

  return res.data;
};

/**
 * 仕分け処理更新API
 * @return
 */
const httpAPI_REC005 = async (
  param: IAPI_REC005_Request
): Promise<IAPI_REC005_Response> => {
  let res = await http.post(ApiUrl.API_REC005, {
    ...param,
  });

  return res.data;
};

/**
 * 仕分け処理解除更新API
 * @return
 */
const httpAPI_REC024 = async (
  param: IAPI_REC024_Request
): Promise<IAPI_REC024_Response> => {
  let res = await http.post(ApiUrl.API_REC024, {
    ...param,
  });

  return res.data;
};

/**
 * 機構他口座振替更新API
 * @return
 */
const httpAPI_REC025 = async (
  param: IAPI_REC025_Request
): Promise<IAPI_REC025_Response> => {
  let res = await http.post(ApiUrl.API_REC025, {
    ...param,
  });

  return res.data;
};

/**
 * 入金一覧参照API
 * @return
 */
const httpAPI_REC017 = async (
  param: IAPI_REC017_Request
): Promise<IAPI_REC017_Response> => {
  let res = await http.post(ApiUrl.API_REC017, {
    ...param,
  });

  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export {
  httpAPI_REC023,
  httpAPI_REC016,
  httpAPI_REC005,
  httpAPI_REC024,
  httpAPI_REC025,
  httpAPI_REC017,
  httpAPI_APP016,
};
